import { NewSheqManager } from "./componenents/NewSheqManager";

export default NewSheqManager;